import styled from '@emotion/styled';
import { HeadingText50 } from '@modernhealth/vital-components';
import { Property } from 'csstype';
import React from 'react';

const LayoutContainer = styled('div')(({ maxWidth }: { maxWidth: string }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: maxWidth,
    boxSizing: 'border-box',
    padding: '0 1rem',
    margin: 'auto',
    gap: '1rem',
}));

const IllustrationContainer = styled('div')({
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
});

interface HeadingContainerProps {
    textAlign: Property.TextAlign;
}
const HeadingContainer = styled('div')<HeadingContainerProps>((props: HeadingContainerProps) => ({
    textAlign: props.textAlign,
}));

const ActionsContainer = styled('div')({
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    gap: 18,
});

interface FlowLayoutProps {
    illustration?: React.ReactNode;
    headingAlign?: Property.TextAlign;
    heading?: string;
    actions?: React.ReactNode[];
    footer?: React.ReactNode;
    maxWidth?: string;
}

export const FlowLayout: React.FC<FlowLayoutProps> = ({
    illustration,
    headingAlign,
    heading,
    actions,
    children,
    footer,
    maxWidth = '500px',
}) => (
    <LayoutContainer maxWidth={maxWidth}>
        {!!illustration && <IllustrationContainer>{illustration}</IllustrationContainer>}
        {!!heading && (
            <HeadingContainer textAlign={headingAlign || 'start'}>
                <HeadingText50 marginBottom={0}>{heading}</HeadingText50>
            </HeadingContainer>
        )}
        {!!children && <div>{children}</div>}
        {!!actions && <ActionsContainer>{actions?.map(action => action)}</ActionsContainer>}
        {footer}
    </LayoutContainer>
);
